var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCurrencyRupee(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.75 11.3333H21.25M14.1667 11.3333C16.5139 11.3333 18.4167 13.2361 18.4167 15.5833C18.4167 17.9306 16.5139 19.8333 14.1667 19.8333H12.75L17 24.0833M12.75 15.5833H21.25M29.75 17C29.75 24.0417 24.0417 29.75 17 29.75C9.95837 29.75 4.25 24.0417 4.25 17C4.25 9.95837 9.95837 4.25 17 4.25C24.0417 4.25 29.75 9.95837 29.75 17Z",
    stroke: "#FF5F14",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCurrencyRupee);
export default __webpack_public_path__ + "static/media/currencyRupee.2dd2454993ef1f021d1600ac8f1647be.svg";
export { ForwardRef as ReactComponent };